// extracted by css-extract-rspack-plugin
export default {"cls1":"ExportFormatModal-cls1_na3","cls2":"ExportFormatModal-cls2_PdE ExportFormatModal-cls1_na3"};